import { Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { getOfferDetailsConfig } from './offerDetailsConfig';
import DOMPurify from 'dompurify';
import { CenterSpinner } from '@/components/ats/loadders';
import { useQuery } from '@tanstack/react-query';
import { fetchSelectOptions } from '@/components/formBuilder/helpers/formHelpers';
import { MarkdownSubtext } from '@/utils/MarkdownSubtext';

interface OfferDetailsSectionProps {
  currentOffer: any;
}

const renderValue = (value: string) => {
  return (
    <KText size="sm-medium" color="secondary-700">
      <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }} />
    </KText>
  );
};

export const OfferDetailsSection = ({
  currentOffer,
}: OfferDetailsSectionProps) => {
  const {
    data: formData = {},
    isLoading: isFormDataLoading,
    isFetching: isFormDataFetching,
  } = useQuery({
    queryKey: ['offer/custom_fields', 'offer'],
    queryFn: async () => {
      const response = await fetchSelectOptions({
        endPoint: 'ats_custom_fields/form_fields?subject_type=ats_offer',
        method: 'get',
      });
      return response || {};
    },
    staleTime: 0,
  });

  if (isFormDataLoading || isFormDataFetching) {
    return (
      <Flex justifyContent="center" alignItems="center" p="24px">
        <CenterSpinner h="200px" />
      </Flex>
    );
  }

  const staticFieldSections = formData?.ats_form_template?.static_fields || [];
  const customFields = formData?.ats_form_fields || [];

  const detailsData = getOfferDetailsConfig(
    currentOffer,
    staticFieldSections,
    customFields
  );

  return (
    <Flex flexDir="column" gap="12px" p="16px">
      {detailsData.map(({ label, value, description }, index) => (
        <Flex key={index} flexDir="column" gap="4px">
          <KText size="sm-semi-bold" color="secondary-700">
            {label}
          </KText>
          {description && (
            <MarkdownSubtext
              markdown={description}
              bodyColor="secondary-500"
              minW={0}
              bg="transparent"
              p={0}
              m={0}
            />
          )}
          {renderValue(value)}
        </Flex>
      ))}
    </Flex>
  );
};
